<div *ngIf="showConsole$ | async" class="w-full {{ (expand$ | async) ? 'h-full' : 'h-32' }} fixed bottom-0 left-0 bg-black p-2" style="z-index: 10000;">
  <button (click)="toggleExpand()" class="text-sm border text-white px-2 py-1 absolute bg-black top-1 left-1">Expand</button>

  <ul class="overflow-y-scroll h-full">
    <li class="w-vw log-{{ log.name}} text-sm py-2" *ngFor="let log of logs$ | async">
      {{ log.text }}
    </li>
  </ul>
</div>
